import React, { useEffect } from 'react';
import './HP.css';
import HPHeader from './HPHeader';
import HPFooter from './HPFooter';

import Faq from 'react-faq-component';

export default function HPFAQ({ createCall, startHairCheck }) {
  const data = {
    rows: [
      {
        title: 'What is FACELESS?',
        content: `FACELESS is an online meeting tool that you don't need to show your face. 
        There is no function to send your face video to others, so you don't need to worry about showing your background or your face. 
        Instead of showing your face, your face is replaced by 2D realstic face. `,
      },
      {
        title: 'What difference between Zoom and FACELESS?',
        content:
          'The biggest differences is that Zoom or Google Meet have function which show your real face. Even though you can turn off the camera, it is always wonder you and participants need to show your face or not.  In FACELESS, you do not need to worry about it. ',
      },
      {
        title: 'Is it free to use?',
        content: `Currently we are in Beta, so you can use it for fee.`,
      },
      {
        title: 'Which platforms are supported?',
        content: `Windows and Mac are supported. Also, Chrome, Firefox and Edge are supported. Safari browser is partially supported. `,
      },
      {
        title: 'Which browsers are supported?',
        content: <p>current version is 1.2.1</p>,
      },
      {
        title: 'iOS or Android app are available?',
        content: <p>current version is 1.2.1</p>,
      },
      {
        title: 'How can I start the meeting?',
        content: <p>current version is 1.2.1</p>,
      },
      {
        title: 'How long can I talk in a meeting?',
        content: <p>current version is 1.2.1</p>,
      },
      {
        title: 'How do I know if my NFT are suppoted or not?',
        content: <p>current version is 1.2.1</p>,
      },
    ],
  };

  const styles = {
    // bgColor: 'white',
    // titleTextColor: 'blue',
    // titleTextSize: '48px',
    // rowTitleColor: 'blue',
    rowTitleTextSize: '15px',
    rowContentColor: 'grey',
    rowContentTextSize: '13px',
    rowContentPaddingTop: '0px',
    rowContentPaddingBottom: '20px',

    // rowContentPaddingLeft: '50px',
    // rowContentPaddingRight: '150px',
    // arrowColor: "red",
    //transitionDuration: "1s",
    // timingFunc: "ease"
  };
  return (
    <>
      <div id="hp-wrap">
        <HPHeader />
        <div id="hp-content">
          <div id="hp-h1">FAQ</div>
          <div id="hp-explain">
            If you have any questions or feedback please send us from contact
          </div>
          <div id="hp-faq">
            <Faq data={data} styles={styles} />
          </div>
        </div>
      </div>
      <HPFooter />
    </>
  );
}
